<template>
  <div>
    <ul class="members-list items-list list-unstyled has-text-info has-text-weight-semibold">
      <template v-if="memberList.length">
        <li v-for="(member, index) in memberList" :key="index">
          <a :href="member.URL" target="_blank" v-if="member.URL && member.URL !== ''">
            {{ member.Company }}
          </a>
          <span v-else>{{ member.Company }}</span>
        </li>
      </template>
      <template v-else>
        <li v-for="(i, index) in 6" :key="`skeleton-${i}-${index}`">
          <span class="skeleton-item"><span class="skeleton-bar"></span></span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MemberList',
  props: {
    urlEndpoint: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      memberList: []
    }
  },
  mounted() {
    this.fetchMemberList();
  },
  methods: {
    async fetchMemberList() {
      try {
        setTimeout(async () => {
          const jsonData = (await axios.get(this.urlEndpoint)).data;
          this.memberList = jsonData.Companies;

        }, 2000)
      } catch (error) {
        this.memberList = [ { Company: 'An unexpected error has occurred', URL: '/' } ]
      }
    }
  },
}
</script>
ss